import Clipboard from 'clipboard';

export class Controller {

    /** @ngInject */
    constructor(
                $scope,
                $state,
                $uibModal,
                Account,
                Alert,
                CorporateSettingsService,
                DestructiveOperationModal) {
        this.$scope = $scope;
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Account = Account;
        this.Alert = Alert;
        this.CorporateSettingsService = CorporateSettingsService;
        this.DestructiveOperationModal = DestructiveOperationModal;
    }

    $onInit() {
        this.newSettings = angular.copy(this.settings);
        this.companyId = this.$state.params.companyId;
        this.credentialsInitialized = false;
        
        this.credentials = {key: null, secret: null, ipFilter: this.newSettings.ipFilter};
        this.setIpFilterVar();

        new Clipboard(".copyCli").on('success', () => {
            this.$scope.$apply(() => {
            this.Alert('success', 'global.data_copied')
            })
        })
    }

    setIpFilterVar(){
        this.ipFilters = this.credentials && this.credentials.ipFilter ? this.credentials.ipFilter.split(";") : null;
    }

    clearNewSettings(){
        this.newSettings = angular.copy(this.settings);
    }

    getCredentials(){
        if (this.settings.hasCredentials) {
            const url = `app/rest/company/${this.companyId}/getCredentials`;
            this.DestructiveOperationModal({
                titleKey: 'corporate.destructive_op.get_credentials.title',
                textKey: 'corporate.destructive_op.get_credentials.text',
                http: {method: 'GET', url}
            }).then((data) => {
                this.getCredentialsCallback(data);
            });
        }
    }

    getCredentialsCallback(data){
        this.credentials = data;
        this.setIpFilterVar();
        this.credentialsInitialized = true;
        this.settings.hasCredentials = true;
        this.clearNewSettings();
    }

    setIpFilterAndOrGenerateCredentialsDestructiveCallback(data,message) {
        this.credentials = data;
        this.setIpFilterVar();
        this.credentialsInitialized = true;
        this.settings.hasCredentials = true;
        this.clearNewSettings();
        this.Alert('success', message);
    }

    editCorporateProfile() {
        this.$uibModal
            .open({
                component: 'editCorporateProfile',
                resolve: {settings: () => this.settings},
            }).result
            .then((settings) => this.save(settings));
    }

    editRecoverySettings() {
        this.CorporateSettingsService
            .save(this.companyId, this.settings)
            .then((settings) => {
                    this.settings = settings;
                    this.newSettings = angular.copy(this.settings);
                    this.Alert('success', 'corporate.message.updated');
                }
            );
    }

    editIpAddressFilter() {
        this.$uibModal
            .open({
                component: 'editCorporateIpAddressFilter',
                resolve: {credentials: () => this.credentials},
            }).result
            .then((result) => {
            	 this.credentials = result;
                 this.setIpFilterVar();
                 this.clearNewSettings();
                 this.Alert('success', 'corporate.message.updated');
            });
    }

    generateCredentials() {
        this.$uibModal
            .open({component: 'generateCorporateCredentials'}).result
            .then(() => this.DestructiveOperationModal({
                titleKey: 'corporate.destructive_op.generate_credentials.title',
                textKey: 'corporate.destructive_op.generate_credentials.text',
                http: {
                    method: 'GET',
                    url: `app/rest/company/${this.companyId}/generateCredentials`,
                }
            }))
            .then((credentials) => {
                this.setIpFilterAndOrGenerateCredentialsDestructiveCallback(credentials,'corporate.message.credentials_updated');
            });
    }

    save(settings) {
        const numbers = [settings.phoneNumber, settings.phoneNumber2].filter((v) => v);
        [settings.phoneNumber, settings.phoneNumber2] = [...new Set(numbers)];

        this.CorporateSettingsService
            .save(this.companyId, settings)
            .then(() => {
                this.settings = settings;
                this.Alert('success', 'corporate.message.updated');
                this.Account.reload();
            })
    }
}


// WEBPACK FOOTER //
// ./src/portal/states/company/corporate-settings/company-profile/company-profile.controller.js